class TC_Faq {
    constructor () {
        if ($('.pricing-faq').length) {
            this.initEvents();
        }
    }

    initEvents () {
        let wrapper = $('.pricing-faq');
        let itemTitles = wrapper.find('.pricing-faq-item-title');

        itemTitles.each((i, title) => {
            title = $(title);
            title.on('click', e => {
                if (title.hasClass('is-active')) {
                    return;
                }

                let prevTitle = wrapper.find('.pricing-faq-item-title.is-active');
                let prevContent = wrapper.find('.pricing-faq-item-title.is-active').next('.pricing-faq-item-content');
                let prevContentHeight = prevContent.find('.pricing-faq-item-content-wrapper').outerHeight();
                prevContent.css('height', prevContentHeight + 'px');

                setTimeout(() => {
                    prevContent.css('height', '0px');
                    prevTitle.removeClass('is-active');
                }, 0);

                let content = title.next('.pricing-faq-item-content');
                content.css('height', '0px');

                setTimeout(() => {
                    let contentHeight = content.find('.pricing-faq-item-content-wrapper').outerHeight();
                    content.css('height', contentHeight + 'px');
                    title.addClass('is-active');
                }, 0);

                setTimeout(() => {
                    prevContent.css('height', '');
                    content.css('height', '');
                }, 400);
            });
        })
    }
}
